import { render, staticRenderFns } from "./Siri.vue?vue&type=template&id=a8464d62&"
import script from "./Siri.vue?vue&type=script&lang=js&"
export * from "./Siri.vue?vue&type=script&lang=js&"
import style0 from "./Siri.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports